import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle, X, Send, Bot } from "lucide-react";

const QUICK_REPLIES = [
  "I want a website",
  "I need an AI chat bot",
  "How fast can you launch?",
];

export const FloatingChat = () => {
  const [open, setOpen] = useState(false);
  const [pulse, setPulse] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setPulse(false), 8000);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <AnimatePresence>
        {open && (
          <motion.div
            key="panel"
            initial={{ opacity: 0, y: 16, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.96 }}
            transition={{ duration: 0.25 }}
            className="fixed bottom-[5.5rem] left-4 md:left-6 z-[55] w-[min(92vw,360px)] rounded-2xl dark:glass-dark glass-light border border-border shadow-2xl overflow-hidden"
            data-testid="floating-chat-panel"
          >
            <div className="flex items-center gap-3 px-4 py-3 border-b border-border">
              <div className="relative h-9 w-9 rounded-xl gradient-saffron grid place-items-center">
                <Bot className="h-4 w-4 text-white" />
                <span className="absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-[#00C853] border-2 border-background" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-sm">DigIndia Assist</div>
                <div className="text-[11px] text-muted-foreground">
                  Avg reply in 2 minutes
                </div>
              </div>
              <button
                onClick={() => setOpen(false)}
                className="h-8 w-8 grid place-items-center rounded-full hover:bg-foreground/5"
                aria-label="Close"
                data-testid="floating-chat-close"
              >
                <X className="h-4 w-4" />
              </button>
            </div>

            <div className="p-4 space-y-3 max-h-[280px] overflow-y-auto scrollbar-hide">
              <div className="max-w-[85%] px-3.5 py-2.5 rounded-2xl rounded-tl-sm bg-foreground/[0.06] dark:bg-white/[0.06] border border-border text-sm">
                Namaste! 🙏 How can we help you go digital today?
              </div>
              <div className="space-y-2 pt-2">
                {QUICK_REPLIES.map((q) => (
                  <button
                    key={q}
                    onClick={() => {
                      const el = document.getElementById("enquiry");
                      if (el) {
                        el.scrollIntoView({ behavior: "smooth" });
                        setOpen(false);
                      } else {
                        window.location.href = "/#enquiry";
                      }
                    }}
                    className="w-full text-left px-3.5 py-2.5 rounded-xl border border-border hover:border-[#FF7A00]/60 hover:bg-[#FF7A00]/5 transition-all text-sm font-medium flex items-center justify-between gap-2"
                    data-testid={`floating-chat-quick-${q.replace(/\s+/g, "-").toLowerCase()}`}
                  >
                    <span>{q}</span>
                    <Send className="h-3.5 w-3.5 text-[#FF9933]" />
                  </button>
                ))}
              </div>
            </div>

            <div className="px-4 py-3 border-t border-border text-[11px] text-muted-foreground flex items-center justify-between">
              <span>Powered by DigIndia AI</span>
              <span className="flex items-center gap-1">
                <span className="h-1.5 w-1.5 rounded-full bg-[#00C853]" />
                Online
              </span>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={() => setOpen((o) => !o)}
        className="fixed bottom-6 left-4 md:left-6 z-[55] h-14 w-14 rounded-full gradient-saffron text-white grid place-items-center shadow-[0_18px_40px_rgba(255,122,0,0.5)] hover:scale-105 transition-transform"
        aria-label="Open chat"
        data-testid="floating-chat-button"
      >
        {pulse && !open && (
          <span className="absolute inset-0 rounded-full animate-ping bg-[#FF7A00]/40" />
        )}
        <span className="relative">
          <AnimatePresence mode="wait" initial={false}>
            <motion.span
              key={open ? "x" : "msg"}
              initial={{ rotate: -90, opacity: 0 }}
              animate={{ rotate: 0, opacity: 1 }}
              exit={{ rotate: 90, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="grid place-items-center"
            >
              {open ? (
                <X className="h-5 w-5" />
              ) : (
                <MessageCircle className="h-5 w-5" />
              )}
            </motion.span>
          </AnimatePresence>
        </span>
      </button>
    </>
  );
};

export default FloatingChat;
